/* Pre-connect screen explaining what YouTube OAuth does. */

import { Button } from "@/components/ui/button";
import { Youtube, Loader2 } from "lucide-react";

interface YouTubeConnectPromptProps {
  onConnect: () => void;
  isLoading: boolean;
  error: string | null;
}

export function YouTubeConnectPrompt({
  onConnect,
  isLoading,
  error,
}: YouTubeConnectPromptProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-4">
      <div className="flex items-center justify-center size-12 rounded-full bg-muted">
        <Youtube className="size-6 text-muted-foreground" />
      </div>

      <div className="text-center space-y-1">
        <p className="text-sm font-medium">Import your YouTube subscriptions</p>
        <p className="text-xs text-muted-foreground">
          Read-only access to see which channels you subscribe to.
          We won't post or modify anything.
        </p>
      </div>

      {error && <p className="text-destructive text-sm text-center">{error}</p>}

      <Button onClick={onConnect} disabled={isLoading} className="w-full">
        {isLoading && <Loader2 className="size-4 animate-spin" />}
        Connect YouTube
      </Button>
    </div>
  );
}
